







































































import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import get from 'lodash/get'
import { SortDirection } from '@/helpers/enums/SortDirection'
import FEIcon from '@/components/ui/FEIcon.ts.vue'


type TableHeaderBase = {
  name: string;
  label: string;
  sortable?: boolean;
  width?: string;
  headerStyle?: string | Record<string, string>;
  headerClass?: string | Record<string, string>;
  style?: string | Record<string, string>;
  class?: string | Record<string, string>;
}

export type TableHeader<Data> =
  | {
  value: keyof Data;
} & TableHeaderBase
  | {
  field: (d: Data, h: TableHeader<Data>, index: number) => unknown;
} & TableHeaderBase

@Component({
  components: {
    FEIcon,
  },
})
export default class FETable<Data> extends Vue {
  @Prop({ type: Array, required: true })
  public headers!: TableHeader<Data>[];

  @Prop({ type: Array, required: true })
  public data!: Data[];

  @Prop({ type: String, default: 'id' })
  public valueKey!: keyof Data;

  @Prop(String)
  public sortKey?: string;

  @Prop(String)
  public sortDirection?: SortDirection;

  public get list() {
    const { headers, data: list } = this

    const hasField = headers.some((header) => 'field' in header)
    if (!hasField) return list

    return list.map((data, index) => {
      const values = headers.reduce((acc, header) => {
        if ('field' in header) {
          const value = header.field.call(this, data, header, index)
          acc[header.name] = value
        } else {
          const value = get(data, header.value)
          acc[header.name] = value
        }

        return acc
      }, {} as Record<string, unknown>)

      return { data, values }
    })
  }

  public changeSort(header: TableHeader<Data>) {
    if (header.name !== this.sortKey) {
      const options = { key: header.name, direction: SortDirection.asc }
      this.$emit('sort', options)
      return options
    }

    let direction: SortDirection | void = void 0

    switch (this.sortDirection) {
      case SortDirection.asc:
        direction = SortDirection.desc
        break

      case SortDirection.desc:
        direction = void 0
        break

      default:
    }

    const options = direction
      ? { key: header.name, direction }
      : {}

    this.$emit('sort', options)

    return options
  }
}
